import { render, staticRenderFns } from "./informe-diario.vue?vue&type=template&id=54df616e"
import script from "./informe-diario.vue?vue&type=script&lang=js"
export * from "./informe-diario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports